import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="spinner"></div>
        <span className="ml-2">Lade...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isActive) {
    return (
      <div className="card max-w-md mx-auto mt-8">
        <div className="text-center">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Account nicht aktiviert</h2>
          <p className="text-gray-600">
            Ihr Account muss von einem Administrator aktiviert werden. 
            Bitte wenden Sie sich an einen Administrator.
          </p>
        </div>
      </div>
    );
  }

  if (requiredRole && !['admin', 'superadmin'].includes(user.role)) {
    return (
      <div className="card max-w-md mx-auto mt-8">
        <div className="text-center">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Zugriff verweigert</h2>
          <p className="text-gray-600">
            Sie haben nicht die erforderlichen Berechtigungen für diese Seite.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
